import { endpoints, request } from '!core/api';

export const userInfoServices = {
  getUserInfo: () => request.get(endpoints.chnn('wsbGetUserInfo')),
};
